import {get, post, postJson} from '../tools/async-tool'
// import {Message} from 'element-ui';

import showErr from './showErr'
// function showErr(err) {
//   // 请求取消
//   // alert(JSON.stringify(err));
//   // console.log(err);
//   // console.log(!!(err.status.match(/canceled/i)), err);
//   if(typeof err.status == 'number' && (err.status == 0)) { return false; }
//   Message({
//     type: 'error',
//     message: err.body.error ? err.body.error : default_err,
//     customClass: 'manban-toast__error'
//   });
// }

export function getProfile (cb, params, failCb = null) {
  let url = '/profile'
  return get(url, params).then(res => {
    	cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function getCurrentOrg (cb, params, failCb = null) {
  let url = '/org'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function modifyProfile (cb, params, failCb = null) {
  let url = '/profile/property'
  return post(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function sendSms (cb, params, failCb = null) {
  let url = '/logincode/send'
  return post(url, params).then(res => {
    cb(res)
  }, err => {
    showErr(err)

    failCb && failCb()
  })
}

export function changeUserMobile (cb, params, failCb = null) {
  let url = '/change_mobile'

  return post(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb()
  })
}

export function getOrgs (cb, params, failCb = null) {
  let url = '/list_orgs/v3' // /list_orgs
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function loginOut (cb, params, failCb = null) {
  let url = '/logout'
  return post(url, params).then(res => {
    cb(res)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function getTaskBox (cb, params, failCb = null) {
  let url = '/statics/task_box'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function usersUnbindWechat (cb, params, failCb = null) {
  let url = '/users/unbind_wechat.json'
  return postJson(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)
    failCb && failCb(err)
  })
}

export function getPcTabs (cb, params, failCb = null) {
  let url = '/pc_tabs'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}

export function getOrgDefaultLevelRanges (cb, params, failCb = null) {
  let url = '/org/default_level_ranges'
  return get(url, params).then(res => {
    cb(res.body)
  }, err => {
    showErr(err)

    failCb && failCb(err)
  })
}
